import React from "react";
import "./LatestProjects.css";

const projects = [
  {
    title: "DC MICROGRID",
    desc:
      "Advanced DC microgrid system for efficient renewable energy integration, smart power distribution, and battery energy management.",
    tech: "Power Systems • Renewable Energy • Smart Grid",
    link: "#",
  },

  {
    title: "Automatic Power Factor Correction",
    desc:
      "Intelligent APFC system designed to improve power quality, reduce reactive power losses, and enhance electrical efficiency.",
    tech: "Electrical Systems • Automation • Power Electronics",
    link: "#",
  },

  {
    title: "PPG Based Signal Extraction",
    desc:
      "Biomedical signal processing project for extracting heart-rate and pulse signals using photoplethysmography techniques.",
    tech: "Biomedical Engineering • Signal Processing • AI",
    link: "#",
  },

  {
    title: "PI Controller",
    desc:
      "Design and implementation of a proportional–integral controller for stable closed-loop control and dynamic response optimization.",
    tech: "Control Systems • MATLAB • Automation",
    link: "#",
  },

  {
    title: "Tesla Coil",
    desc:
      "High-voltage resonant transformer project demonstrating wireless energy transfer and electrical discharge generation.",
    tech: "High Voltage • Resonance • Electrical Engineering",
    link: "#",
  },
];

const LatestProjects = () => {
  return (
    <section
      className="latest-projects-section"
      id="latest-projects"
    >

      <h2 className="latest-title">
        🚀 Latest Projects
      </h2>

      <div className="latest-project-grid">

        {projects.map((project, index) => (

          <div
            className="modern-project-card"
            key={index}
          >

            <div className="project-content">

              <div className="project-number">
                0{index + 1}
              </div>

              <h3>{project.title}</h3>

              <p>{project.desc}</p>

              <span>{project.tech}</span>

              <a
                href={project.link}
                target="_blank"
                rel="noreferrer"
                className="project-btn"
              >
                View Details →
              </a>

            </div>

            <div className="card-glow"></div>

          </div>

        ))}

      </div>

    </section>
  );
};

export default LatestProjects;